// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/bao-menu";
import "./../bindings/bao-date-time-box";
import "./../bindings/element";
import * as $ from "jquery";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog, { DialogButton } from "./../factories/bao-dialog";
import * as moment from "moment";
import BaoDialogViewModel from "./../factories/bao-dialog";
import SwapDialog from "./../factories/shift-schedule-swap-employees-dialog";
import BaoMenu from "./../services/bao-shouter";

import ShiftScheduleEditCellDialog from "./dialogs/shift-schedule-edit-cell-dialog";
import ShiftAbsenceDialog from "./../view-models/dialogs/shift-absence-dialog";

class ShiftScheduleViewModel extends BaseViewModel {
    Years: string[] = [];
    Calendar: KnockoutObservable<any> = ko.observable([]);
    Employees: KnockoutObservable<any> = ko.observable([]);
    ShiftGroups: any[];
    PermissionApplyHolidayForOtherPersons = ko.observable(false);
    PermissionApplyHolidayForMyself = ko.observable(false);
    PermissionEmployeeSwapShift = ko.observable(false);
    CurrentUsersPersonId = ko.observable(null);
    SumShiftStrength: KnockoutObservable<any> = ko.observable([]);
    /**
     * Filter SumShiftStrength based on ShiftbookName and ShiftgroupName
     * @param shiftbookName
     * @param groupName
     */
    filterSumShiftStrength = (shiftbookName, groupName) => {
        return ko.utils.arrayFilter(this.SumShiftStrength(), (item: any) => {
            return item.ShiftbookName == shiftbookName && item.ShiftGroupName == groupName;
        });
    }
    ShowSummedShiftOccupation = ko.observable(false);
    CompleteCheck() {
        return true;
    }
    DislpayOverlayCreateAbsenceBtn = ko.pureComputed(() => {
        if (this.PermissionApplyHolidayForOtherPersons()) {
            return true;
        }
        if (this.PermissionApplyHolidayForMyself() === false) {
            return false;
        }
        if (this.SelectedCellData() !== null && this.SelectedCellData().EmployeeId === this.CurrentUsersPersonId()) {
            return true;
        }
        else {
            return false;
        }
    });
    DislpayOverlaySwapShiftBtn = ko.pureComputed(() => this.PermissionEmployeeSwapShift());
    DislpayOverlayEditShiftBtn = ko.pureComputed(() => this.PermissionEditShiftPlanEntries());
    DislpayOverlayGenerateShiftBtn = ko.pureComputed(() => this.PermissionGenerateShiftPlan());
    CellOverlay: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    OverlaySwapHtmlElement: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    OverlayAbsenceSwapHtmlElement: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    /** Selected Cell's data
     */
    SelectedCellData: KnockoutObservable<any> = ko.observable(null);
    EmployeeOverlay: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    SelectedEmployeeData: KnockoutObservable<any> = ko.observable(null);
    ShiftstrengthOverlay: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    SelectedShiftstrengthData: KnockoutObservable<any> = ko.observable(null);
    RemarkPopupHtmlElement: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    HoveredOverCellData: KnockoutObservable<any> = ko.observable(null);
    ShiftScheduleItems: any[];
    StrengthSumOverlay: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    SelectedStrengthSumData: KnockoutObservable<any> = ko.observable(null);
    // filters
    SelectedYear: KnockoutObservable<number> = ko.observable(new Date().getFullYear());
    SelectedMonth: KnockoutObservable<number> = ko.observable(new Date().getMonth() + 1);
    ShiftGroupId: KnockoutObservableArray<string> = ko.observableArray([]);
    ShiftGroupIdStringifiedForCustomFilter: KnockoutObservable<string> = ko.observable("");
    ShiftGroupName: KnockoutObservable<string> = ko.observable("");
    PersonId: KnockoutObservableArray<string> = ko.observableArray([]);
    PersonName: KnockoutObservable<string> = ko.observable("");
    QualificationId: KnockoutObservableArray<string> = ko.observableArray([]);
    QualificationIdStringifiedForCustomFilter: KnockoutObservable<string> = ko.observable("");
    QualificationName: KnockoutObservable<string> = ko.observable("");
    ScheduleFilters: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    ShiftbookIds: KnockoutObservableArray<string> = ko.observableArray([]);
    ShiftbookIdsStringifiedForCustomFilter: KnockoutObservable<string> = ko.observable("");
    ShiftbookNames: KnockoutObservable<string> = ko.observable("");
    Display: KnockoutObservable<string> = ko.observable('horizontal'); // select with boolean does not work
    PermissionRefresh: KnockoutObservable<string> = ko.observable("na");
    PermissionSave: KnockoutObservable<string> = ko.observable("na");
    PermissionDelete: KnockoutObservable<string> = ko.observable("na");
    PermissionQRCode: KnockoutObservable<string> = ko.observable("na");
    PermissionShowWeakShiftdays: KnockoutObservable<boolean> = ko.observable(false);
    PermissionEditShiftPlanEntries: KnockoutObservable<boolean> = ko.observable(false);
    PermissionGenerateShiftPlan: KnockoutObservable<boolean> = ko.observable(false);
    EmployeesToShow: KnockoutObservable<any> = ko.observableArray([]);
    ShiftEntriesPerDay: KnockoutObservableArray<any> = ko.observableArray([]);
    SidebarTop: KnockoutObservable<string> = ko.observable('0');
    HeaderLeft: KnockoutObservable<string> = ko.observable('0');
    EmployeeCellOverlayTop: KnockoutObservable<number> = ko.observable(0);
    EmployeeCellOverlayLeft: KnockoutObservable<number> = ko.observable(0);
    ShiftstrengthOverlayTop: KnockoutObservable<number> = ko.observable(0);
    ShiftstrengthOverlayLeft: KnockoutObservable<number> = ko.observable(0);
    ClearShiftplanInTimeInterval: KnockoutObservable<string> = ko.observable('');
    GenerateShiftSchedule: KnockoutObservable<string> = ko.observable('');
    ShowShiftstrengthInfo: KnockoutObservable<string> = ko.observable('');
    ApplyVacationAttributeTitle: KnockoutObservable<string> = ko.observable('');
    SwapShiftAttributeTitle: KnockoutObservable<string> = ko.observable('');
    EditShiftAttributeTitle: KnockoutObservable<string> = ko.observable('');
    PermissionFilterEnableShiftbook = ko.observable(false);
    PermissionFilterEnableShiftgroup = ko.observable(false);
    PermissionFilterEnablePerson = ko.observable(false);
    StrengthSumOverlayTop: KnockoutObservable<number> = ko.observable(0);
    StrengthSumOverlayLeft: KnockoutObservable<number> = ko.observable(0);

    ShowDetailsInDialog = ko.observable(false);
    TicketApproveStateApproved: KnockoutObservable<string> = ko.observable('');
    TicketApproveStateNotApproved: KnockoutObservable<string> = ko.observable('');
    TicketApproveStateUnedited: KnockoutObservable<string> = ko.observable('');
    TicketStatusClosed: KnockoutObservable<string> = ko.observable('');
    TicketStatusWaitForApproval: KnockoutObservable<string> = ko.observable('');

    DeleteBlockingTicketMessage = Bao.Session.GetMessage("msgDeleteBlockingTicketMessage");

    constructor(tabPage: TabPage) {
        super(tabPage);
        this.TabPage.MenuEvents.push(this.Menu.registerEvent((btnClicked) => {
            if (this.TabPage.IsActiveTab() !== true) {
                return;
            }
            if (btnClicked.ActionKey() === "TeamScheduleSwapShiftPlans") {
                this.SwiftSwapDialog();
            }
            if (btnClicked.ActionKey() === "TeamScheduleRefresh") {
                this.RefreshSchedule();
            }
            if (btnClicked.ActionKey() === "TeamScheduleReportPdf") {
                this.TabPage.IsLoading(true);
                Bao.post("SynosetReportCenter/GenerateShiftPlanReport", JSON.stringify({
                    year: this.SelectedYear(),
                    month: this.SelectedMonth(),
                    personId: this.PersonId(),
                    qualificationId: this.QualificationId(),
                    shiftGroupId: this.ShiftGroupId(),
                    shiftbookIds: this.ShiftbookIds()
                }), (result) => {
                    if (result.Result) {
                        window.open(Bao.Content("BaoDocument/Download/" + result.Message), "_blank"); // zum Testen der Berichts-PDF
                        this.TabPage.IsLoading(false);
                    }
                    else {
                        let dialog = new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                        this.TabPage.IsLoading(false);
                    }
                });
            }
        }));
        this.GenerateShiftSchedule = Bao.Session.GetMessage("msgGenerateShiftSchedule");
        this.ClearShiftplanInTimeInterval = Bao.Session.GetMessage("msgClearShiftplanInTimeInterval");
        this.ShowShiftstrengthInfo = Bao.Session.GetMessage("msgShowShiftstrengthInfo");
        this.ApplyVacationAttributeTitle = Bao.Session.GetMessage("msgApplyVacationAttributeTitle");
        this.SwapShiftAttributeTitle = Bao.Session.GetMessage("msgSwapShiftAttributeTitle");
        this.EditShiftAttributeTitle = Bao.Session.GetMessage("msgEditShiftAttributeTitle");
    }
    // required by base class
    InitUrl() {
        return "";
    }
    /**
    * wird benutzt um die action-keys auszuwerten
    */
    FormName = ko.observable<string>("TeamSchedule");
    loadMetaData() {
        // permission to show weak shiftDays
        this.PermissionShowWeakShiftdays = Bao.Session.HasPermission('ShowShiftPlanAlarm', '1A38B671-948C-42EE-B80D-F6B9A12814B6');
        return Bao.post("ShiftSchedule/TeamScheduleMetaData")
            .done((result: {
                TabTitle: string;
                Years: Models.HashObject[];
                PermissionApplyHolidayForOtherPersons: boolean;
                PermissionApplyHolidayForMyself: boolean;
                PermissionEmployeeSwapShift: boolean;
                PermissionEditShift: boolean;
                PermissionShowWeakShiftdays: boolean;
                PermissionGenerateShiftPlan: boolean;
                CurrentUsersPersonId: string;
                CurrentUsersPersonShiftbookId: string;
                CurrentUsersPersonShiftbookName: string;
                CurrentUsersPersonShiftGroupId: string;
                CurrentUsersPersonShiftGroupName: string;
                PermissionFilterEnableShiftbook: boolean;
                PermissionFilterEnableShiftgroup: boolean;
                PermissionFilterEnablePerson: boolean;
                CurrentDisplay: string,
                ShowDetailsInDialog: boolean,
                TicketApproveStateApproved: string,
                TicketApproveStateNotApproved: string,
                TicketApproveStateUnedited: string,
                TicketStatusClosed: string,
                TicketStatusWaitForApproval: string,
            }) => {
                this.TabPage.Title(result.TabTitle);
                for (var r in result.Years) {
                    if (result.Years[r].Key != "" && result.Years[r].Key != null)
                        this.Years.push(result.Years[r].Key);
                }
                this.PermissionApplyHolidayForOtherPersons(result.PermissionApplyHolidayForOtherPersons);
                this.PermissionApplyHolidayForMyself(result.PermissionApplyHolidayForMyself);
                this.PermissionEmployeeSwapShift(result.PermissionEmployeeSwapShift);
                this.PermissionEditShiftPlanEntries(result.PermissionEditShift);
                this.PermissionShowWeakShiftdays(result.PermissionShowWeakShiftdays);
                this.PermissionGenerateShiftPlan(result.PermissionGenerateShiftPlan);
                this.ShowDetailsInDialog(result.ShowDetailsInDialog);
                this.TicketApproveStateApproved(result.TicketApproveStateApproved);
                this.TicketApproveStateNotApproved(result.TicketApproveStateNotApproved);
                this.TicketApproveStateUnedited(result.TicketApproveStateUnedited);
                this.TicketStatusClosed(result.TicketStatusClosed);
                this.TicketStatusWaitForApproval(result.TicketStatusWaitForApproval);
                this.CurrentUsersPersonId(result.CurrentUsersPersonId);
                if (result.CurrentUsersPersonShiftbookId !== null) {
                    this.ShiftbookIds([result.CurrentUsersPersonShiftbookId]);
                }
                if (result.CurrentUsersPersonShiftbookName !== null) {
                    this.ShiftbookNames(result.CurrentUsersPersonShiftbookName);
                }
                if (result.CurrentUsersPersonShiftGroupId !== null) {
                    this.ShiftGroupId([result.CurrentUsersPersonShiftGroupId]);
                }
                if (result.CurrentUsersPersonShiftbookName !== null) {
                    this.ShiftGroupName(result.CurrentUsersPersonShiftGroupName);
                }
                this.PermissionFilterEnableShiftbook(result.PermissionFilterEnableShiftbook);
                this.PermissionFilterEnableShiftgroup(result.PermissionFilterEnableShiftgroup);
                this.PermissionFilterEnablePerson(result.PermissionFilterEnablePerson);
                if (result.CurrentDisplay != null && result.CurrentDisplay != "") {
                    this.Display(result.CurrentDisplay);
                }
            });
    }
    loadSchedule() {
        this.HideAllOverlays();
        this._oldLoadScheduleFilterJson = this._stringifyCurrentFilter();
        return Bao.post("ShiftSchedule/TeamScheduleData", JSON.stringify({
            year: this.SelectedYear(),
            month: this.SelectedMonth(),
            personId: this.PersonId(),
            qualificationId: this.QualificationId(),
            shiftGroupId: this.ShiftGroupId(),
            shiftbookIds: this.ShiftbookIds()
        })).done(result => {
            this.Employees(result.EmployeeCollection);
            //ko.map.fromJS(result, this); this maps also properties to observables
            this.Calendar(result.Calendar);
            //this.ShiftScheduleItems  = result.ShiftScheduleItems;
            this.SumShiftStrength(result.SumShiftStrengthCollection);
            this.ShowSummedShiftOccupation(result.ShowSummedShiftOccupation);
        });
    }
    recalcTableValues() {
        let employees = ko.unwrap(this.Employees);
        let newEmployeesToShow = []
        for (const employee of employees) {
            let newEmployee: any = {
                Name: employee.Name,
                EmployeeId: employee.Id,
                ShiftbookName: employee.ShiftbookName,
                GroupName: employee.ShiftGroupName,
                GroupShortName: employee.ShiftGroupShortName,
                DefaultQualificationName: employee.DefaultQualificationName
            }
            let newCalendar = []
            for (const cal of employee.Calendar) {
                newCalendar.push({
                    EmployeeId: employee.Id,
                    EmployeeName: employee.Name,
                    ...cal
                });
            }
            newEmployee.Calendar = newCalendar;
            newEmployeesToShow.push(newEmployee);
        }
        this.EmployeesToShow(newEmployeesToShow);

        //this.ShiftEntriesPerDay(this.Calendar().map(day =>
        //    this.EmployeesToShow().map(column =>
        //        this.ShiftScheduleItems
        //            .filter(item => this.SelectedShiftEntryId() === undefined || item.ShiftEntryId === this.SelectedShiftEntryId())
        //            .filter(item => day.Day === item.Day && column.EmployeeId === item.EmployeeId).map(item => item.ShiftEntryId)[0]))
        //);
    }
    init() {
        this.TabPage.IsLoading(true);
        this.QualificationId.subscribe(newValue => {
            if (Array.isArray(newValue)) {
                this.QualificationIdStringifiedForCustomFilter(JSON.stringify(newValue));
            }
            else {
                this.QualificationIdStringifiedForCustomFilter(newValue);
            }
        });
        this.ShiftbookIds.subscribe(newValue => {
            if (Array.isArray(newValue)) {
                this.ShiftbookIdsStringifiedForCustomFilter(JSON.stringify(newValue));
            }
            else {
                this.ShiftbookIdsStringifiedForCustomFilter(newValue);
            }
        });
        this.ShiftGroupId.subscribe(newVal => {
            if (Array.isArray(newVal)) {
                this.ShiftGroupIdStringifiedForCustomFilter(JSON.stringify(newVal));
            }
            else {
                this.ShiftGroupIdStringifiedForCustomFilter(newVal);
            }
        });
        return $.when(super.init(), this.loadMetaData())
            .then(_ => this.loadSchedule())
            .then(_ => this.recalcTableValues());
    }
    _oldLoadScheduleFilterJson = "";
    RefreshTriggeredByInputSubscribers() {
        let currentFilter = this._stringifyCurrentFilter();
        if (this._oldLoadScheduleFilterJson === currentFilter) {
            //cancel refresh, because filter didnt change
            return;
        }
        else {
            this.RefreshSchedule();
        }
    }
    _stringifyCurrentFilter() {
        return JSON.stringify({
            year: this.SelectedYear(),
            month: this.SelectedMonth(),
            personId: this.PersonId(),
            qualificationId: this.QualificationId(),
            shiftGroupId: this.ShiftGroupId(),
            shiftbookIds: this.ShiftbookIds()
        });
    }
    RefreshSchedule() {
        this.TabPage.IsLoading(true);
        this.loadSchedule()
            .then(_ => this.recalcTableValues())
            .then(_ => this.TabPage.IsLoading(false));
    }
    private ResizeEventHandler = (e) => {
        this.recalcSchedulePosition();
        this.recalcScroll();
    };
    private ScrollEventHandler = (e) => {
        e.preventDefault();
        this.recalcScroll();
    };
    loaded() {
        super.loaded();
        this.SelectedYear.subscribe(_ => this.RefreshTriggeredByInputSubscribers());
        this.SelectedMonth.subscribe(_ => this.RefreshTriggeredByInputSubscribers());
        this.PersonId.subscribe(_ => this.RefreshTriggeredByInputSubscribers());
        this.ShiftGroupId.subscribe(_ => this.RefreshTriggeredByInputSubscribers());
        this.QualificationId.subscribe(_ => this.RefreshTriggeredByInputSubscribers());
        this.ShiftbookIds.subscribe(_ => this.RefreshTriggeredByInputSubscribers());
        ;
        this.Display.subscribe(x => {
            window.scrollTo(0, 0);
            this.recalcSchedulePosition();
            this.recalcScroll();
            this.HideAllOverlays();
            $(this.RemarkPopupHtmlElement()).hide();
            Bao.post("ShiftSchedule/SaveCurrentDisplay", JSON.stringify({
                currentDisplay: this.Display()
            }));
        });
        // IMPORTANT: Do NOT forget do remove Event Listener (see this.BeforeClose())
        window.addEventListener('scroll', this.ScrollEventHandler);
        window.addEventListener('resize', this.ResizeEventHandler);
        this.recalcSchedulePosition();
        this.recalcScroll();
        this._oldLoadScheduleFilterJson = this._stringifyCurrentFilter();
        this.TabPage.IsLoading(false);
        this.TabPage.IsActiveTab.subscribe((newval) => {
            if (newval) {
                this.recalcSchedulePosition();
                this.recalcScroll();
            }
        });

        if ($('head style#dataTableRow')[0] == undefined) {
            $('head').append('<style id="dataTableRow" type="text/css">'
                + '.schedule-table .body.stack .content .table-row.stack:not(:nth-child(1)):hover:after {'
                + 'left:-' + $('div.sidebar.item:first').width() + 'px'
                + '}</style > ');
        }
    }
    recalcScroll() {
        this.SidebarTop(document.getElementById('content').getBoundingClientRect().top + 'px');
        this.HeaderLeft(-window.pageXOffset + 'px');
        if (this.Display() == 'horizontal') {
            $(this.EmployeeOverlay()).css("top", (this.EmployeeCellOverlayTop() - window.pageYOffset + "px"));
        }
        if (this.Display() == 'vertical') {
            $(this.EmployeeOverlay()).css("left", (this.EmployeeCellOverlayLeft() - window.pageXOffset + "px"));
        }
        // this must be always set independent if display is horizontal or vertical, because this header is always fixed and not the body ...
        $(this.ShiftstrengthOverlay()).css("top", (this.ShiftstrengthOverlayTop() - window.pageYOffset + "px"));
        $(this.ShiftstrengthOverlay()).css("left", (this.ShiftstrengthOverlayLeft() - window.pageXOffset + "px"));
        $(this.StrengthSumOverlay()).css("top", (this.StrengthSumOverlayTop() - window.pageYOffset + "px"));
        $(this.StrengthSumOverlay()).css("left", (this.StrengthSumOverlayLeft() - window.pageXOffset + "px"));
    }
    recalcSchedulePosition() {
        $(".schedule-table").css("top", $(".schedule-filters").height());
    }
    // override to avoid this.unlockurl-call
    BeforeClose(closeFn) {
        // remove the eventlistener
        window.removeEventListener('scroll', this.ScrollEventHandler);
        window.removeEventListener('resize', this.ResizeEventHandler);
        // call closeFn(callback) to accept the close and close it
        return closeFn();
    }
    SwiftSwapDialog(personId?: string, date?: string, personName?: string) {
        let dialog = new SwapDialog(this.TabPage.IsLoading, personId, null, date, personName);
        dialog.IsLoading(true);
        dialog.Dialog().then((swapSuccess) => {
            if (swapSuccess) {
                this.TabPage.IsLoading(true);
                this.loadSchedule()
                    .then(() => this.recalcTableValues()).then(() => this.TabPage.IsLoading(false));
            }
        });
    }
    HoverOverCell(data: any, event: {
        target: HTMLElement;
    }) {
        $(this.RemarkPopupHtmlElement()).hide();
        this.HoveredOverCellData(null);
        if (data.HasRemark || data.IsVario) {
            this.HoveredOverCellData(data);
            this.ShowRemarkPopup(event.target, 1, 1);
        }
    }
    ShowRemarkPopup(target, offsetx, offsety) {
        if (target !== null) {
            const rect = target.getBoundingClientRect();
            const top = rect.top + offsety + $(window).scrollTop() - (this.Display() == 'horizontal' ? rect.height * 2 + 6 : 0);
            $(this.RemarkPopupHtmlElement()).css("top", (this.Display() == 'horizontal') ? top + 5 : top)
                .css("left", rect.right + offsetx + $(window.document).scrollLeft())
                .css("overflow", 'auto')
                .width(242 - offsetx - 1)
                .height(rect.height * 2 - 4)
                .show();
        }
    }
    ClickOnEmployee(data: any, event: {
        target: HTMLElement;
    }) {
        let element = event.target;
        if (this.SelectedEmployeeData() !== null && data.EmployeeId === this.SelectedEmployeeData().EmployeeId) {
            this.HideAllOverlays();
            return;
        }
        this.HideAllOverlays();
        this.SelectedEmployeeData(data);
        if ($(element).parents(".no-children").length > 0) {
            element = $(element).parents(".no-children").first()[0];
        }
        this.CreateEmployeeOverlay(element, 2, 2);
    }
    CreateEmployeeOverlay(target, offsetx, offsety) {
        if (target !== null) {
            let rect = target.getBoundingClientRect();
            $(this.EmployeeOverlay()).css("top", rect.top - 8 - offsety)
                .css("left", rect.left)
                .width(rect.width - offsetx - 1)
                .height(rect.height - 2)
                .show();
            this.EmployeeCellOverlayTop(rect.top - 8 - offsety);
            this.EmployeeCellOverlayLeft(rect.left);
        }
    }
    ClickOnDay(data: any, event: {
        target: HTMLElement;
    }) {
        // if day has no red marking: no nothing OR Permission is not set!
        if (!this.PermissionShowWeakShiftdays() || (data != null && !data.ShiftStrengthTooWeak)) {
            return;
        }
        let element = event.target;
        // if selecting same cell: unselect
        if (this.SelectedShiftstrengthData() !== null && data.Day === this.SelectedShiftstrengthData().Day) {
            this.HideAllOverlays();
            return;
        }
        this.HideAllOverlays();
        this.SelectedShiftstrengthData(data);
        if ($(element).parents(".no-children").length > 0) {
            element = $(element).parents(".no-children").first()[0];
        }
        this.CreateShiftstrengthOverlay(element, 2, 2);
    }

    ClickOnStrengthSum(data: any, event: { target: HTMLElement }) {
        let element = event.target;

        // if selecting same cell: unselect
        if (this.SelectedStrengthSumData() !== null && data.Day === this.SelectedStrengthSumData().Day) {
            this.HideAllOverlays();
            return;
        }
        this.HideAllOverlays();
        this.SelectedStrengthSumData(data);

        if ($(element).parents(".no-children").length > 0) {
            element = $(element).parents(".no-children").first()[0];
        }
        this.CreateStrengthSumOverlay(element, 2, 2);
    }

    CreateStrengthSumOverlay(target, offsetx, offsety) {
        if (target.tagName == "SPAN") {
            target = target.parentElement;
        }
        if (target !== null) {
            let rect = target.getBoundingClientRect();
            $(this.StrengthSumOverlay()).css("top", rect.top - 8 - offsety)
                .css("left", rect.left)
                .width(rect.width - offsetx - 1)
                .height(rect.height - 2)
                .show();
            this.StrengthSumOverlayTop(rect.top - 8 - offsety);
            this.StrengthSumOverlayLeft(rect.left);
        }
    }

    CreateShiftstrengthOverlay(target, offsetx, offsety) {
        if (target.tagName == "SPAN") {
            target = target.parentElement;
        }
        if (target !== null) {
            let rect = target.getBoundingClientRect();
            $(this.ShiftstrengthOverlay()).css("top", rect.top - 8 - offsety)
                .css("left", rect.left)
                .width(rect.width - offsetx - 1)
                .height(rect.height - 2)
                .show();
            this.ShiftstrengthOverlayTop(rect.top - 8 - offsety);
            this.ShiftstrengthOverlayLeft(rect.left);
        }
    }

    ClickStrengthSumInfo() {
        if (this.SelectedStrengthSumData() != null && this.SelectedStrengthSumData().MissingForShiftStrength !== null) {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, this.SelectedStrengthSumData().MissingForShiftStrength, "info");
            dialog.WidthStyle("600px");
        }
    }

    ClickOnCell(data: any, event: {
        target: HTMLElement;
    }) {
        let element = event.target;
        // set data for click-event-handlers
        if (this.SelectedCellData() !== null && data.Date === this.SelectedCellData().Date && data.EmployeeId === this.SelectedCellData().EmployeeId) {
            this.HideAllOverlays();
            return;
        }
        this.HideAllOverlays();
        this.SelectedCellData(data);
        if ($(element).parents(".no-children").length > 0) {
            element = $(element).parents(".no-children").first()[0];
        }
        // Bugfix: show overlay only on week days
        if (this.SelectedCellData().Weekday !== "") {
            this.createOverlay(element, 2, 2);
        }
    }
    createOverlay(target, offsetx, offsety) {
        if (target !== null) {
            let rect = target.getBoundingClientRect();
            $(this.CellOverlay()).css("top", rect.top - 8 - offsety + $(window).scrollTop())
                .css("left", rect.left + $(window.document).scrollLeft())
                .width(rect.width - offsetx - 1)
                .height(rect.height - 2)
                .show();
        }
    }
    /**
     * Event Handler vor Overlays Button Swap Shift
     */
    ClickSwapShift() {
        let data = this.SelectedCellData();
        this.SwiftSwapDialog(data.EmployeeId, moment(data.Date).format(Bao.Utils.DateTimeFormat), data.EmployeeName);
    }
    /**
     * Event Handler vor Overlays Button Create Absence
     */
    ClickCreateAbsence() {
        let data = this.SelectedCellData();
        var defaultDateTrue = false;
        var TicketExists = false;

        if (this.ShowDetailsInDialog() === true) {
            return Bao.post("Holiday/GetHolidayCollection",
                JSON.stringify({
                    dayFrom: moment(data.Date).format(Bao.Utils.DateTimeFormat),
                    dayTo: moment(data.Date).format(Bao.Utils.DateTimeFormat),
                    personId: data.EmployeeId
                })
            ).done(result => {
                if (result.AbsenceCollection.length > 0) {
                    var ticketId = result.AbsenceCollection[0].TicketId;
                    TicketExists = true;
                    this.OpenShiftAbsenceDialog(ticketId, moment(data.Date).format(Bao.Utils.DateTimeFormat), defaultDateTrue, TicketExists);
                    this.TabPage.IsLoading(true);
                }
                // New absence
                else {
                    this.TabPage.IsLoading(true);
                    defaultDateTrue = true
                    this.OpenShiftAbsenceDialog(data.EmployeeId, moment(data.Date).format(Bao.Utils.DateTimeFormat), defaultDateTrue, TicketExists);
                }
            });
        }
        else {
            // Check if an absence already exist, if yes open
            return Bao.post("Holiday/GetHolidayCollection",
                JSON.stringify({
                    dayFrom: moment(data.Date).format(Bao.Utils.DateTimeFormat),
                    dayTo: moment(data.Date).format(Bao.Utils.DateTimeFormat),
                    personId: data.EmployeeId
                })
            ).done(result => {
                if (result.AbsenceCollection.length > 0) {
                    var ticketId = result.AbsenceCollection[0].TicketId;
                    window.location.hash = "#/holiday/" + ticketId
                }
                // New absence
                else {
                    window.location.hash = "#/holiday/person/" + data.EmployeeId + "/date/" + moment(data.Date).format(Bao.Utils.DateTimeFormat)
                }
            });
        }
    }

    OpenShiftAbsenceDialog(data: any, date: any, defaultDateTrue?: any, TicketExits?: any) {
        let tab = new TabPage();
        let dialog = new ShiftAbsenceDialog(tab, this, this.TicketApproveStateApproved, this.TicketApproveStateNotApproved, this.TicketApproveStateUnedited, this.TicketStatusClosed, this.TicketStatusWaitForApproval);
        dialog.Dialog(data, date, defaultDateTrue, TicketExits);
    }

    ClickEditCell() {
        this.TabPage.IsLoading(true);
        this.OpenEditCellDialog(this.SelectedCellData());
    }
    ClickGenerateShiftPlan() {
        let data = this.SelectedEmployeeData();
        window.location.hash = "#/NewScheduleGeneration/personId/" + data.EmployeeId + "/personName/" + data.Name;
    }
    ClickEditShiftplan(data: any) {
        this.TabPage.IsLoading(true);
        this.OpenEditShiftplanDialog(this.SelectedEmployeeData());
    }
    ClickShiftstrengthInfo() {
        if (this.SelectedShiftstrengthData() != null && this.SelectedShiftstrengthData().MissingForShiftStrength !== null) {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, this.SelectedShiftstrengthData().MissingForShiftStrength, "info");
            dialog.WidthStyle("600px");
        }
    }
    ClearShiftsInTimeInterval(data: any) {
        this.TabPage.IsLoading(true);
        const regExp = new RegExp(/^\d{14}$/);
        const dateFrom = regExp.test(data.DateFrom()) ? data.DateFrom() :
            data.DateFrom().substr(0, 4) + data.DateFrom().substr(5, 2) + data.DateFrom().substr(8, 2) + '000000';
        let dateTo = regExp.test(data.DateTo()) ? data.DateTo() :
            data.DateTo().substr(0, 4) + data.DateTo().substr(5, 2) + data.DateTo().substr(8, 2) + '000000';
        if (dateTo < dateFrom) {
            data.DateTo(dateFrom);
            dateTo = dateFrom;
        }
        this.UpdateShiftType(dateFrom, dateTo).then(() => {
            this.TabPage.IsLoading(false);
        });
    }
    UpdateShiftType(dateFrom: string, dateTo: string) {
        return Bao.post("ShiftSchedule/DeleteShiftEntityInTimeInterval", JSON.stringify({
            EmployeeId: this.SelectedEmployeeData().EmployeeId,
            FromDay: dateFrom,
            ToDay: dateTo
        })).then(result => {
            return this.loadSchedule()
                .then(_ => {
                    return this.recalcTableValues();
                });
        });
    }
    OpenEditShiftplanDialog(data: any) {
        const dialog = new BaoDialog(Bao.Session.GetMessage("msgClearShifts"));
        dialog.Width("650px");
        dialog.Buttons([
            {
                Title: Bao.Session.GetMessage("msgClear"),
                Click: () => {
                    dialog.Close();
                    this.ClearShiftsInTimeInterval(dialog.ViewModel());
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { },
            },
            {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: () => {
                    dialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(false),
                Focus: () => { },
            }
        ]);
        dialog.IsLoading(true);
        Bao.post("ShiftSchedule/TeamScheduleData", JSON.stringify({
            year: this.SelectedYear(),
            month: this.SelectedMonth(),
            personId: [data.EmployeeId],
            qualificationId: this.QualificationId(),
            shiftGroupId: this.ShiftGroupId(),
            shiftbookIds: this.ShiftbookIds()
        })).done(result => {
            const shifts = result.EmployeeCollection[0].Calendar; //.filter(day => day.ShiftTypeId !== null);
            shifts.forEach(s => { s.Date = ko.observable<string>(s.Date); });
            const shiftEntries = ko.observableArray(shifts);
            Bao.post("ShiftSchedule/GetEditShiftplanDialogTemplate").done(result => {
                dialog.ViewModel({
                    year: this.SelectedYear(),
                    month: this.SelectedMonth(),
                    EmployeeName: data.Name,
                    EmployeeId: data.EmployeeId,
                    ShiftEntries: shiftEntries,
                    DateFrom: ko.observable<string>(new Date().toISOString()),
                    DateTo: ko.observable<string>(new Date().toISOString())
                });
                dialog.Template(result.Message);
                dialog.Open();
                dialog.IsLoading(false);
                this.TabPage.IsLoading(false);
            });
        });
    }
    HideAllOverlays() {
        $(this.CellOverlay()).hide();
        $(this.EmployeeOverlay()).hide();
        $(this.ShiftstrengthOverlay()).hide();
        $(this.StrengthSumOverlay()).hide();
        this.SelectedCellData(null);
        this.SelectedEmployeeData(null);
        this.SelectedShiftstrengthData(null);
        this.SelectedStrengthSumData(null);
    }

    /**
    * Opens a dialog for editing cell data. The dialog will present an option to either save the current
    * cell data or delete a "blocking ticket" if the selected date corresponds to a holiday.
    * @param {any} data - The data of the cell to be edited.
    */
    OpenEditCellDialog(data: any) {
        const dialog = new BaoDialog(Bao.Session.GetMessage("msgEdit"));
        dialog.Width("450px");
        dialog.Buttons([
            {
                Title: Bao.Session.GetMessage("msgOk"),
                Click: () => {
                    this.CheckHoliday(data)
                        .done(holidayId => {
                            if (holidayId && Object.keys(holidayId).length !== 0) {
                                dialog.Close();
                                this.DeleteBlockingTicketDialog(dialog.ViewModel(), holidayId);
                            } else {
                                this.SaveCell(dialog.ViewModel());
                                dialog.Close();
                            }
                        })
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { },
            },
            {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: () => { dialog.Close(); },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(false),
                Focus: () => { },
            }
        ]);

        Bao.post("ShiftSchedule/GetEditCellDialogTemplate").done(result => {
            dialog.ViewModel(new ShiftScheduleEditCellDialog(this, data));
            dialog.Template(result.Message);
            dialog.Open();  // Open the dialog after setting up the ViewModel and Template
        });

        this.TabPage.IsLoading(false);
    }

    /**
     * Checks if the selected date for the given employee corresponds to a holiday.
     * @param {any} data - The data that includes the `EmployeeId` and the `Date` to be checked.
     * @returns {Promise} - A promise that resolves with the holidayId if the date is a holiday, or null otherwise.
     */
    CheckHoliday(data: any) {
        return Bao.post("ShiftSchedule/CheckHoliday", JSON.stringify({
            EmployeeId: ko.unwrap(data.EmployeeId),
            Date: ko.unwrap(data.Date)
        }));
    }

    /**
     * Opens a dialog for deleting a "blocking ticket" (i.e., a holiday).
     * @param {any} data - The data of the cell where the blocking ticket resides.
     * @param {string} holidayId - The ID of the holiday to be deleted.
     */
    DeleteBlockingTicketDialog(data: any, holidayId: string) {
        const dialog = new BaoDialog(Bao.Session.ApplicationName, this.DeleteBlockingTicketMessage);
        dialog.Width("450px");
        dialog.Buttons([
            new DialogButton(dialog, Bao.Session.GetMessage("msgOk"), () => {
                this.DeleteBlockingTicket(holidayId);
                dialog.Close();
                this.SaveCell(data);
            }),
            new DialogButton(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            })
        ]);

        dialog.Open();

        this.TabPage.IsLoading(false);
    }

    /**
     * Deletes a "blocking ticket" (i.e., a holiday) with the given ID.
     * @param {string} holidayId - The ID of the holiday to be deleted.
     */
    DeleteBlockingTicket(holidayId: string) {
        this.TabPage.IsLoading(true);
        Bao.post("Holiday/Delete", JSON.stringify({
            id: holidayId
        })).then(() => {
            this.TabPage.IsLoading(false);
        })
    }

    /**
     * Saves the cell data by sending a POST request with the data to the "ShiftSchedule/SaveCell" endpoint.
     * After the cell data is saved, the schedule is reloaded and the table values are recalculated.
     * The cell that corresponds to the saved data is selected.
     * @param {any} data - The data to be saved.
     */
    SaveCell(data: any) {
        this.TabPage.IsLoading(true);
        Bao.post("ShiftSchedule/SaveCell", JSON.stringify({
            CIPersonId: ko.unwrap(data.EmployeeId),
            ShiftTypeId: ko.unwrap(data.ShiftTypeId),
            ShiftGroupId: ko.unwrap(data.ShiftGroupId),
            ValidDate: ko.unwrap(data.Date),
            Remark: ko.unwrap(data.Remark),
            IsVario: ko.unwrap(data.IsVario),
            OrginalShiftTypeId: ko.unwrap(data.OrginalShiftTypeId),
            SyncId : ko.unwrap(data.SyncId)
        })).done(result => {
            this.loadSchedule()
                .then(() => {
                    this.recalcTableValues();

                    //hack for this.SelectedCellData(this.EmployeesToShow().find(e => e.EmployeeId === data.EmployeeId).Calendar.find(c => c.Date === data.Date()));
                    let cellData = null;
                    let employees = this.EmployeesToShow();
                    for (var e_i in employees) {
                        let e = employees[e_i];
                        if (cellData === null && ko.unwrap(e.EmployeeId) === ko.unwrap(data.EmployeeId)) {
                            for (var cal_i in e.Calendar) {
                                let c = e.Calendar[cal_i];
                                if (cellData === null && ko.unwrap(c.Date) === ko.unwrap(data.Date)) {
                                    cellData = c;
                                }
                            }
                        }
                    }
                    // hack end
                    this.SelectedCellData(cellData);
                    this.TabPage.IsLoading(false);
                });
        });
    }
}
export default ShiftScheduleViewModel;